package org.vreo.devicehub.features.userAuthentication.data.dto

import kotlinx.serialization.Serializable

/**
 * Verification dto
 *
 * @property email email address
 * @property code verification code
 */
@Serializable
data class VerificationDto(
    val email: String,
    val code: String
)